var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('h1',[_vm._v("Error ("+_vm._s(_vm.fetchingErrorCode)+")")]),_c('p',[_vm._v(_vm._s(_vm.fetchingError))]),_c('a',{staticClass:"btn button et_pb_button margin-top-23",on:{"click":_vm.restart}},[_vm._v("Zurück")])])
}
var staticRenderFns = []

export { render, staticRenderFns }